import { render, staticRenderFns } from "./yycZhuangCheDan.vue?vue&type=template&id=61a65ced&scoped=true&"
import script from "./yycZhuangCheDan.vue?vue&type=script&lang=js&"
export * from "./yycZhuangCheDan.vue?vue&type=script&lang=js&"
import style0 from "./yycZhuangCheDan.vue?vue&type=style&index=0&id=61a65ced&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a65ced",
  null
  
)

export default component.exports